function Inventory(props) {
  return (
    <div>
      <h2>Inventory</h2>
    </div>
  );
}

export default Inventory;
